<div
    class="relative w-full"
    role="region">
    <div class="flex flex-col py-2">
        @for (bar of config().bars; track $index; let last = $last) {
            <div
                class="flex items-center z-[1] gap-2"
                [ngClass]="last ? 'mb-4' : 'mb-6'"
                role="figure">
                <div
                    class="h-6 {{ bar.barClass }} print:border print:border-current"
                    [style]="getBarStyle(bar.percentage)"
                    [attr.aria-valuenow]="bar.percentage"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    attr.aria-label="{{ bar.label }}"></div>
                <span [ngClass]="bar.labelClass">{{ bar.label }}</span>
            </div>
        }
    </div>
    <div
        class="absolute inset-0 w-full h-full pointer-events-none"
        aria-hidden="true">
        @for (measure of config().measures; track $index; let last = $last; let first = $first) {
            <div
                class="absolute w-px h-full bg-gray-300"
                [style]="getDividerStyle(measure.percentage)">
                <span
                    class="absolute bottom-0 translate-y-full"
                    [ngClass]="{ '-translate-x-1/2 left-1/2': !last, 'right-0': last || first }">
                    {{ measure.label }}
                </span>
            </div>
        }
    </div>
</div>
